import { useState } from "react";
import { cn } from "@/lib/utils";

type LogoProps = {
	className?: string;
	src?: string;
};

export function Logo({ className, src }: LogoProps) {
	const [imgError, setImgError] = useState(false);

	if (src && !imgError) {
		return (
			<img
				src={src}
				alt="Logo"
				className={cn("h-8 max-w-[120px] object-contain", className)}
				onError={() => setImgError(true)}
			/>
		);
	}

	return (
		<div className={cn("flex items-center gap-2.5", className)}>
			<LogoIcon className="size-8 shrink-0" />
			<span className="truncate font-semibold text-lg tracking-wide uppercase">
				Metriso
			</span>
		</div>
	);
}

export function LogoIcon({ className }: { className?: string }) {
	return (
		<svg
			aria-hidden="true"
			width="39"
			height="38"
			viewBox="0 0 39 38"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={cn("size-8", className)}
		>
			<path
				d="M24.6622 18.9935C24.6622 15.5831 21.8351 12.8214 18.3514 12.8211C14.8675 12.8211 12.0393 15.5829 12.0393 18.9935C12.0395 22.404 14.8676 25.1659 18.3514 25.1659C21.835 25.1656 24.662 22.4038 24.6622 18.9935ZM26.8068 18.9935C26.8067 23.5559 23.0231 27.2584 18.3514 27.2587C13.6795 27.2587 9.8948 23.5561 9.89465 18.9935C9.89465 14.4307 13.6794 10.7283 18.3514 10.7283C23.0232 10.7286 26.8068 14.4309 26.8068 18.9935Z"
				fill="currentColor"
			/>
			<path
				d="M36.6477 18.9932C36.6477 9.73234 28.9541 2.22475 19.4638 2.22475C9.9735 2.22475 2.27988 9.73234 2.27988 18.9932C2.27988 28.254 9.9735 35.7616 19.4638 35.7616C28.9541 35.7616 36.6477 28.254 36.6477 18.9932ZM38.9276 18.9932C38.9276 29.4829 30.2135 37.9863 19.4638 37.9863C8.71412 37.9863 0 29.4829 0 18.9932C0 8.50342 8.71412 0 19.4638 0C30.2135 0 38.9276 8.50342 38.9276 18.9932Z"
				fill="currentColor"
			/>
			<path
				d="M26.1144 16.1587C26.1144 10.453 21.3747 5.82786 15.5276 5.82786C9.68052 5.82789 4.94075 10.453 4.94072 16.1587C4.94072 21.8644 9.6805 26.4896 15.5276 26.4896C21.3747 26.4896 26.1144 21.8645 26.1144 16.1587ZM28.5852 16.1587C28.5852 23.1958 22.739 28.9006 15.5276 28.9006C8.31617 28.9006 2.46997 23.1958 2.46997 16.1587C2.47 9.12171 8.31619 3.41688 15.5276 3.41685C22.739 3.41685 28.5852 9.1217 28.5852 16.1587Z"
				fill="currentColor"
			/>
		</svg>
	);
}
